import React, { lazy } from 'react';
import { Route, Switch, Redirect, HashRouter } from 'react-router-dom';
import Loadable from '../ui-component/Loadable';



// login option 3 routing
const AuthLogin3 = Loadable(lazy(() => import('../views/pages/authentication/authentication3/Login3')));

//-----------------------|| AUTHENTICATION ROUTING ||-----------------------//

const AuthenticationRoutes = () => {
    return (
        <HashRouter>
            <Switch>
                <Route path="/" exact>
                    <Redirect to="/login" />
                </Route>
                <Route path="/login" component={AuthLogin3} />
                <Route path="**" exact>
                    <Redirect to="/login" />
                </Route>
            </Switch>
        </HashRouter>
    );
};

export default AuthenticationRoutes;
